export default {
    lateralhead: {
        name: 'ميلان الرأس',
        key: 'Head tilt',
        definition: 'When standing, the head leans to the left or right',
        harm: {
            bone: 'Cervical lateral flexion',
            muscle: 'The flexion side: sternocleidomastoid muscle, scalene muscle, levator scapulae, and cervical muscle。Lengthened side: sternocleidomastoid muscle lengthening, scalene muscle lengthening, neck muscle lengthening, levator scapulae lengthening',
            neurovascular: 'Unilateral vertebral artery compression and unilateral cervical nerve compression',
            des: 'Long term lateral deviation of the neck is easy to lead to chronic strain of the posterior cervical muscles, vertebral hyperplasia, and cervical spondylosis'
        },
        risks: [
            {
                name: 'إصابة مزمنة في العضلات والأربطة',
                des: 'Prolonged cephalic tilt or torticollis may lead to chronic strain of the posterior cervical ligament and surrounding muscles.'
            },
            {
                name: 'داء الفقار العنقي',
                des: 'The neck is a chain of 7 bones connected by ligaments and wrapped in muscles which supports a 15lb weight – your head! Neck pain is a painful problem often'
            }
        ],
    },
    forwardhead: {
        name: 'انحناء الرأس للأمام',
        key: 'forwardhead',
        definition: 'Excessive forward extension of head。',
        harm: {
            bone: 'Straightening or reverse arch of cervical vertebra',
            muscle: 'The sternocleidomastoid muscle is shortened and tense, the upper trapezius muscle bundle is excessively elongated, the splenius capitis and the splenius cervicis are excessively elongated, the levator scapulae is tense, and the scalene muscle is shortened and tense',
            neurovascular: 'Shortening of sternocleidomastoid muscle can induce facial pain Straightening of the vertebral arch reduces the intervertebral foramen space and compresses the cervical nerves and vertebral arteries Excessive shortening of trapezius muscle may compress subclavian artery, leading to insufficient blood supply to the arm',
            des: 'For every 2.5cm of head tilt forward, the weight of neck will be increased by 4kg. Extend 6-9 cm forward, and the load on the neck will exceed the weight of 20 liters of water.\n' +
                'The head tilting forward can also cause dizziness, shaking, pain in the eyes, nausea, anorexia, long-term cervical spondylosis, periarthritis of shoulder and migraine, decreased thinking ability, decreased abdominal pressure, lumbar instability, nerve compression, tension headache, decreased vital capacity, slow blood circulation, and affect the cerebral blood supply.'
        },
        risks: [
            {
                name: 'دوخة وصداع',
                des: 'Brain hypoxia caused by poor circulation arising from posture with the head forward。'
            },
            {
                name: 'داء الفقار العنقي',
                des: 'The neck is a chain of 7 bones connected by ligaments and wrapped in muscles。'
            },
        ]
    },
    unevenshoulder: {
        name: 'تفاوت في مستوى الكتفين',
        key: 'unevenshoulder',
        definition: 'If the difference between the left and right heights of the acromion is more than 2cm, it means uneven shoulders',
        harm: {
            bone: 'Spinal scoliosis, pelvic obliquity, long and short legs, high shoulder blade lifting, unilateral arch collapse',
            muscle: 'High side: levator scapulae shortening and tension, upper trapezius shortening and tension, rhomboid muscle tension, scalene muscle shortening and tension, pectoralis minor muscle lengthening, subclavian muscle tension, saw anterior muscle lengthening and tension.',
            neurovascular: '',
            des: 'It is easy to cause chronic pain, chronic headache, and incorrect posture of high and low shoulders in the neck and shoulders, which makes the load borne by the cervical spine too heavy, and finally may lead to the degeneration of the cervical spine, which is easy to form bone spurs.The high and low shoulders cause the displacement of the pelvis, so that the muscle strength of the lumbar tissue is not balanced, leading to low back pain. At the same time, pelvic displacement will also change the leg length.'
        },
        risks: [
            {
                name: 'صداع مزمن',
                des: 'Uneven shoulders may eventually lead to chronic headaches.'
            },
            {
                name: 'نتوء عظمي',
                des: 'Shoulders that are not level generate abnormal force on the neck, making a person'
            },
            {
                name: 'آلام أسفل الظهر',
                des: 'Slanted shoulders may cause lateral pelvis tilt, waist muscle imbalance, and low back pain.'
            },
            {
                name: 'طول الساقين غير متساوٍ',
                des: 'Pelvic side-tilt also increases the risk of an apparent inequality in the length of legs.'
            }
        ]
    },
    roundedshoulder: {
        name: 'أكتاف مستديرة',
        key: 'roundedshoulder',
        definition: 'As the pectoralis minor is passively shortened, the shoulder blade is drawn forward, making the shoulder forward and downward, resulting in a round shoulder.',
        harm: {
            bone: 'Shoulder blade abduction and chest reduction',
            muscle: 'Shortening and tension of pectoralis major and pectoralis minor, excessive lengthening of rhomboid muscle, and lengthening of trapezius muscle',
            neurovascular: '',
            des: 'Round shoulders can cause shoulder and neck pain. If it is serious, it can compress the cervical nerves, causing headache and arm numbness. The curvature of the neck is reduced and stiff, causing insufficient blood supply to the brain. The round shoulder will make the diaphragm in a tense state, causing the compression of the great arteries and vena cava, which will increase the workload of the heart'
        },
        risks: [
            {
                name: 'عبء القلب الزائد',
                des: 'Rounded shoulders make the diaphragm tense up, increasing the risk of'
            },
            {
                name: 'صداع',
                des: 'Neck and shoulder tension that rounds the shoulders can even cause cervical nerve'
            },
            {
                name: 'تنميل في الذراع',
                des: 'ervical nerve compression can also bring on numbness or paresthesia of the arms.'
            }
        ]
    },
    scoliosis: {
        name: 'الجنف',
        key: 'scoliosis',
        definition: 'One or more segments of the spine bend laterally with vertebral rotation It is a three-dimensional spinal deformity.',
        harm: {
            bone: 'S-shaped bending or C-shaped bending of spine',
            muscle: 'The concave side muscle is short and weak, and the convex side muscle is stretched and weak and loose',
            neurovascular: '',
            des: 'Scoliosis can lead to uneven shoulders, unequal legs and feet, hunched back and short stature. It will also cause chest deformation, abdominal cavity reduction, and then cause back pain, nerve damage, limb sensory disorders and other symptoms. It can also lead to indigestion, loss of appetite, dysfunction of lung blood gas exchange, accelerated heart beat, confusion, shortness of breath, fullness of chest and abdomen, muscle weakness of limbs, different reaction sensitivity of limbs, weak physical strength, etc'
        },
        risks: [
            {
                name: 'الجنف',
                des: 'Further 3-D inspection is indicated to diagnose scoliosis.'
            },
            {
                name: 'تفاوت في مستوى الكتفين',
                des: 'Scoliosis may be accompanied by uneven shoulders.'
            },
            {
                name: 'ميلان الحوض',
                des: 'Scoliosis may be accompanied by uneven hips.'
            }
        ]
    },
    unevenhip: {
        name: 'ميلان الحوض',
        key: 'unevenhip',
        definition: 'The connecting lines of the upper edges of the bilateral iliac crest shown on the X-ray film are not on the same horizontal line',
        harm: {
            bone: 'Pelvic tilt',
            muscle: 'High side: the quadratus lumbaris muscle is tense, the high iliopsoas muscle is tense, the gluteus medius muscle is tense, and the gluteus maximus is tense. Low side: weakness of gluteus maximus, weakness of lengthened psoas, weakness of lengthened iliopsoas',
            neurovascular: '',
            des: 'Pelvic tilting may cause waist and leg pain, sciatica, lumbar disc herniation, gluteal muscle or leg muscle atrophy, scoliosis, chest pain, high and low shoulders, long and short legs. When the legs are together, the knees may not be the same height, dysmenorrhea, shoulder and neck pain.'
        },
        risks: [
            {
                name: 'ألم مزمن',
                des: 'Uneven hips may cause extremity pain.'
            },
            {
                name: 'انزلاق غضروفي قطني',
                des: 'Uneven hips may increase the risk of lumbar disc herniation.'
            },
            {
                name: 'طول الساقين غير متساوٍ',
                des: 'Uneven hips may increase the risk of leg length discrepancy.'
            }
        ]
    },
    oleg: {
        name: 'الأرجل O',
        key: 'oleg',
        definition: 'It refers to that when the lower limbs are naturally straightened or standing, the inner ankles of the feet can touch each other but the knees cannot close',
        harm: {
            bone: 'O-leg (genu varus)',
            muscle: 'Hip external rotator muscle tension, hip internal rotator muscle weakness, gluteus maximus weakness, excessive femoral anteversion',
            neurovascular: '',
            des: 'The lateral muscles of the lower limbs are developed, while the medial muscles are weak, the medial meniscus is worn, and the tibial plateau collapses, leading to osteoarthritis.'
        },
        risks: [
            {
                name: 'إصابة الغضروف المفصلي',
                des: 'The force on the lower limb of bow-legged individuals is altered so that '
            },
            {
                name: 'التهاب المفاصل',
                des: 'Severe bow legs may eventually progress to osteoarthritis on the lateral interstitial space of the joint.'
            }
        ]
    },
    xleg: {
        name: 'الأرجل X',
        key: 'xleg',
        definition: 'It refers to that when the two feet are standing together, the knee joints on both sides touch each other, but the inner ankles of the two feet cannot close together',
        harm: {
            bone: 'X-leg (genu valgus)',
            muscle: 'Hip abductor weakness, medial head of quadriceps femoris, tension of hip internal rotator, tension of biceps femoris, tension of iliotibial band',
            neurovascular: '',
            des: 'It affects the appearance and gives people a certain sense of inferiority. The genu varus changes the force line of the lower limbs, and the inner space of the knee joint bears more pressure than the normal load. In the long run, it causes degeneration of the inner space of the knee joint, which may eventually develop into pain caused by osteoarthritis of the knee joint, causing degeneration of the outer space of the knee joint. In serious cases, artificial joint replacement is required.'
        },
        risks: [
            {
                name: 'إصابة الغضروف المفصلي',
                des: 'Because knock knees alter the direction of force on the lower limb, the knee is subject to increased lateral pressure. Lateral meniscus strain and injury often result.'
            },
            {
                name: 'التهاب المفاصل',
                des: 'Severe genu valgum may eventually progress to osteoarthritis.'
            }
        ]
    },
    kneehyperextension: {
        name: 'فرط تمدد الركبة',
        key: 'kneehyperextension',

        definition: 'In the process of walking or standing, the knee joint of the lower limb is over stretched (the knee extension angle is greater than 5 °), the body center of gravity moves backward, the hip joint is over flexed, and the body tends to lean backward during the support period.',
        harm: {
            bone: 'Insufficient ankle dorsiflexion, making the knee unable to move forward',
            muscle: 'The gluteus maximus is weak, the quadriceps femoris is weak in many cases, the hamstring muscles are overactive, the ligaments around the ankle joint are tense, and the ligaments around the knee joint and joint capsule are loose',
            neurovascular: '',
            des: 'Limited extension of knee joint, poor control of knee joint, deep sensory disorder of lower limbs, and abnormal movement mode'
        },
        risks: [
            {
                name: 'تنكس مفصل الركبة',
                des: 'Excessive wear and degeneration of the knee is the result of persistent back knee.'
            },
            {
                name: 'إضعاف التوازن الجسدي',
                des: 'Deformed knees lead to position changes of the hips, pelvis, and ankles, and can gradually modify the balance of the whole body.'
            }
        ]
    },
    xoleg: {
        name: 'الأرجل XO',
        key: 'xoleg',
        definition: 'Femur and tibia are in internal rotation position, and the lower legs of both sides cannot be close together',
        harm: {
            bone: 'XO-leg',
            muscle: 'XO-leg',
            neurovascular: '',
            des: 'The XO leg, femur and tibia are in internal rotation, and there is a large gap between the lower legs on both sides, which cannot be close together, affecting the appearance. Because the position of femur and tibia is relatively unbalanced, the pressure is more likely to be concentrated on the outside of the knee joint, and knee joint pain and even knee arthritis are more likely to occur'
        },
        risks: [
            {
                name: 'آلام الركبة',
                des: 'Due to the relative imbalance between the femur and tibia caused by XO-leg, the pressure is more likely to be concentrated on the outside of the knee joint, and knee joint pain is more likely to occur'
            },
            {
                name: 'التهاب مفصل الركبة',
                des: 'Severe XO-leg may eventually develop into knee osteoarthritis.'
            }
        ]
    }
}